import { Action, combineReducers } from 'redux';
import { awsApi, baseApi, productInformationApi } from 'services/api/base';
import { reducer as remixerReducers } from './remixer';
import { reducer as distributionReducers } from './distribution';
import { reducer as newSongsReducers } from './newSongs';
import baseStore from './base';
import userStore from './user';
import authStore from './auth';
import songsStore from './songs';
import tagsStore from './tags';
import { reducer as aiSongGeneratorReducers } from './ai/aiSongGeneratorSlice';
import { reducer as bundlesReducers } from './bundles';
import discoveryStore from './discovery';
import { logout as logoutAction } from './auth/actions';

const appReducer = combineReducers({
  base: baseStore.reducer,
  user: userStore.reducer,
  auth: authStore.reducer,
  songs: songsStore.reducer,
  tags: tagsStore.reducer,
  ai: aiSongGeneratorReducers,
  bundles: bundlesReducers,
  discovery: discoveryStore.reducer,
  remixer: remixerReducers,
  distribution: distributionReducers,
  newSongs: newSongsReducers,
  [awsApi.reducerPath]: awsApi.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [productInformationApi.reducerPath]: productInformationApi.reducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: RootState | undefined,
  action: Action
): RootState => {
  if (action.type === logoutAction.type) {
    // Reset state to initial values by passing `undefined`
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
